<template>
  <donut-slack-preview
    avatar-path="graphics/shoutouts/user-headshot"
    :avatar-version="0"
    :hide-name="true"
    :message="message"
    :reacji-list="reacjiList"
  />
</template>

<script setup>
  import { computed } from 'vue';
  import { useStore } from 'vuex';

  const { state } = useStore();
  const props = defineProps({
    points: { type: Number, default: 7 },
  });

  const message = 'Great presentation :::@mike:::! Keep it up!';
  const reacjiList = computed(() => [{ emoji: state.pointsConfig.config.emoji, count: props.points }]);
</script>
